import type { CSSObject } from "@emotion/serialize";

export const size = (width: string, height = width): CSSObject => {
  return { width: width, height: height };
};
